import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";

import { ButtonProps } from "./types";
interface ActionButtonProps {
  action?: {
    positiveBtn?: ButtonProps;
    negativeBtn: ButtonProps;
  };
  className?: string;
}

const useStyles = makeStyles(
  () => ({
    btn: {
      ...{
        "& span label": {
          cursor: "pointer"
        },
        "&.Mui-disabled": {
          backgroundColor: "#F1F2F3"
        },
        "&.Mui-disabled span label": {
          color: "#BEBEBE"
        }
      }
    },
    btnContainer: {
      display: "flex",
      justifyContent: "flex-end",
      width: "330px"
    },
    iconContainer: {
      backgroundColor: "#FFD15C",
      borderRadius: "6px",
      height: "35px",
      width: "35px"
    },
    iconContent: {
      width: "20px"
    },
    negativeBtn: {
      backgroundColor: "#EC5D77",
      ...{
        "& span label": {
          color: "#fff"
        },
        "&:hover": {
          backgroundColor: "#CD5C5C"
        }
      },
      marginLeft: "20px"
    }
  }),
  {
    name: "ActionButtons"
  }
);

function ActionButtons(props: ActionButtonProps) {
  const { className } = props;
  const { negativeBtn, positiveBtn } = props.action;
  const classes = useStyles(props);

  return (
    <div className={className ? className : classes.btnContainer}>
      {positiveBtn &&
        (positiveBtn.type === "icon" ? (
          <IconButton
            color="primary"
            className={classes.iconContainer}
            disabled={positiveBtn.disabled}
            onClick={positiveBtn.onClick}
          >
            {positiveBtn.icon.type === "img" ? (
              <img
                src={positiveBtn.icon.src}
                className={
                  positiveBtn.icon.className
                    ? positiveBtn.icon.className
                    : classes.iconContent
                }
              />
            ) : (
              positiveBtn.icon.children
            )}
          </IconButton>
        ) : (
          <Button
            className={classes.btn}
            color="primary"
            variant="contained"
            onClick={positiveBtn.onClick}
            disabled={positiveBtn.disabled}
          >
            <label>{positiveBtn.label}</label>
          </Button>
        ))}
      {negativeBtn &&
        (negativeBtn.type === "icon" ? (
          <IconButton
            color="primary"
            className={classes.iconContainer}
            disabled={negativeBtn.disabled}
            onClick={negativeBtn.onClick}
          >
            {negativeBtn.icon.type === "img" ? (
              <img
                src={negativeBtn.icon.src}
                className={
                  negativeBtn.icon.className
                    ? negativeBtn.icon.className
                    : classes.iconContent
                }
              />
            ) : (
              negativeBtn.icon.children
            )}
          </IconButton>
        ) : (
          <Button
            className={classNames(classes.negativeBtn, classes.btn)}
            color="primary"
            variant="contained"
            onClick={negativeBtn.onClick}
            disabled={negativeBtn.disabled}
          >
            <label>{negativeBtn.label}</label>
          </Button>
        ))}
    </div>
  );
}

export default ActionButtons;
